import * as XLSX from "xlsx";

// CSV File Download Function
const CSVFileDownload = (columns, fileName) => {
  // Convert JSON to sheet
  const worksheet = XLSX.utils.json_to_sheet(columns);

  // Convert the sheet to CSV format
  const csv = XLSX.utils.sheet_to_csv(worksheet);

  // Create a Blob from the CSV data
  const blob = new Blob([csv], {
    type: "text/csv;charset=utf-8;",
  });

  // Create an object URL for the blob
  const url = URL.createObjectURL(blob);

  // Create a temporary anchor element to trigger the download
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${fileName}.csv`); // Set the file name with .csv extension

  // Append the link to the document body and trigger the click event to start the download
  document.body.appendChild(link);
  link.click();

  // Remove the link element from the document body
  document.body.removeChild(link);
};

export default CSVFileDownload;
